// Client mirror of server/services/passwordPolicy.js. Keep the two in step — they cannot import
// each other (separate bundles), so the only thing holding them together is that each names the
// other.
//
// This exists because the rule used to be hand-copied into three pages and they had DRIFTED:
// profile.js allowed any characters, while add-user.js and edit-user.js used
// /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,16}$/ — alphanumeric only, silently rejecting every
// symbol. All three displayed the same "8-16 characters long" text, so neither admin page stated
// the rule it was applying. A fourth copy was not the fix.
//
// Client-side checks are for feedback only. The server enforces; see finding #17.

export const MIN_LENGTH = 8;
export const MAX_LENGTH = 64;
// bcrypt truncates past 72 BYTES, not characters. TextEncoder, not Buffer — react-scripts 5 runs
// webpack 5, which ships no Buffer polyfill, so Buffer.byteLength would throw in the browser.
export const MAX_BYTES = 72;

const byteLength = (value) => new TextEncoder().encode(value).length;

// Individual requirements, so the Profile page can tick them off as the user types.
export const checkRequirements = (password) => ({
  length: password.length >= MIN_LENGTH && password.length <= MAX_LENGTH && byteLength(password) <= MAX_BYTES,
  case: /[a-z]/.test(password) && /[A-Z]/.test(password),
  number: /\d/.test(password),
});

export const isValidPassword = (password) => {
  if (typeof password !== 'string' || !password) return false;
  const r = checkRequirements(password);
  return r.length && r.case && r.number;
};

// The text shown to the user. Kept here so the three pages cannot drift apart again, and so the
// copy always describes the rule actually being applied.
export const REQUIREMENT_TEXT = [
  `${MIN_LENGTH}-${MAX_LENGTH} characters long`,
  'at least one uppercase and one lowercase character',
  'at least one number',
];

export default {MIN_LENGTH, MAX_LENGTH, MAX_BYTES, checkRequirements, isValidPassword, REQUIREMENT_TEXT};
